import React from 'react';
import ButtonTooltipBadge from '../ButtonTooltipBadge/ButtonTooltipBadge';
import { ButtonEventProps } from './ButtonEvent.type';

const ButtonEvent: React.FC<ButtonEventProps> = ({ onClick }) => {
  return (
    <ButtonTooltipBadge
      dataTestId="button-event"
      onClick={onClick}
      title={'All Event'}
      content={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <mask
            id="mask0_2719_500"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2719_500)">
            <path
              d="M9 16.5C7.675 16.5 6.59375 16.2906 5.75625 15.8719C4.91875 15.4531 4.5 14.9125 4.5 14.25C4.5 13.8125 4.68125 13.4313 5.04375 13.1063C5.40625 12.7812 5.90625 12.525 6.54375 12.3375L6.975 13.7625C6.7625 13.825 6.56875 13.9031 6.39375 13.9969C6.21875 14.0906 6.1 14.175 6.0375 14.25C6.2 14.45 6.575 14.625 7.1625 14.775C7.75 14.925 8.3625 15 9 15C9.6375 15 10.2531 14.925 10.8469 14.775C11.4406 14.625 11.8188 14.45 11.9813 14.25C11.9188 14.175 11.8 14.0906 11.625 13.9969C11.45 13.9031 11.2563 13.825 11.0438 13.7625L11.475 12.3375C12.1125 12.525 12.6094 12.7812 12.9656 13.1063C13.3219 13.4313 13.5 13.8125 13.5 14.25C13.5 14.9125 13.0813 15.4531 12.2437 15.8719C11.4062 16.2906 10.325 16.5 9 16.5ZM9 14.25C8.8625 14.25 8.7375 14.2094 8.625 14.1281C8.5125 14.0469 8.43125 13.9375 8.38125 13.8C8.09375 12.9125 7.73125 12.1687 7.29375 11.5688C6.85625 10.9688 6.43125 10.3938 6.01875 9.84375C5.61875 9.29375 5.27188 8.725 4.97812 8.1375C4.68437 7.55 4.5375 6.825 4.5375 5.9625C4.5375 4.7125 4.96875 3.65625 5.83125 2.79375C6.69375 1.93125 7.75 1.5 9 1.5C10.25 1.5 11.3063 1.93125 12.1688 2.79375C13.0312 3.65625 13.4625 4.7125 13.4625 5.9625C13.4625 6.825 13.3188 7.55 13.0312 8.1375C12.7437 8.725 12.3938 9.29375 11.9813 9.84375C11.5813 10.3938 11.1594 10.9688 10.7156 11.5688C10.2719 12.1687 9.90625 12.9125 9.61875 13.8C9.56875 13.9375 9.4875 14.0469 9.375 14.1281C9.2625 14.2094 9.1375 14.25 9 14.25ZM9 7.55625C9.4375 7.55625 9.8125 7.4 10.125 7.0875C10.4375 6.775 10.5938 6.4 10.5938 5.9625C10.5938 5.525 10.4375 5.15 10.125 4.8375C9.8125 4.525 9.4375 4.36875 9 4.36875C8.5625 4.36875 8.1875 4.525 7.875 4.8375C7.5625 5.15 7.40625 5.525 7.40625 5.9625C7.40625 6.4 7.5625 6.775 7.875 7.0875C8.1875 7.4 8.5625 7.55625 9 7.55625Z"
              fill="white"
            />
          </g>
        </svg>
      }
    />
  );
};

export default ButtonEvent;
